var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M880 1804 c-331 -64 -572 -279 -662 -591 -32 -112 -32 -314 0 -426 80 -279 290 -489 569 -569 112 -32 314 -32 426 0 279 80 489 290 569 569 32 112 32 314 0 426 -79 277 -290 489 -564 568 -72 20 -278 34 -338 23z m330 -163 c199 -68 361 -230 432 -431 20 -56 23 -84 23 -210 0 -126 -3 -154 -23 -210 -71 -201 -231 -361 -432 -432 -56 -20 -84 -23 -210 -23 -126 0 -154 3 -210 23 -201 71 -363 234 -431 432 -30 89 -38 267 -15 364 56 239 254 441 491 500 91 23 290 16 375 -13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981 1526 c-8 -9 -10 -157 -9 -531 3 -468 5 -519 19 -528 24 -15 165 15 243 51 142 66 257 216 291 377 18 88 18 122 0 209 -45 214 -207 376 -420 421 -87 18 -110 19 -124 1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBw);
export default __webpack_public_path__ + "static/media/bw.d0b951bfce96ced13647da1b7b201285.svg";
export { ForwardRef as ReactComponent };